import client from 'api/apiClient';

export const deleteBasket = async (id: any) => {
    try {
        const resposeDeleteData = await client.delete(`/event/${id}`, {});
        return resposeDeleteData;
    } catch (error) {
        console.error('Error Delete Basket', error);
    }
};
